<template>
  <div id="app">
    <commonhead :active_menu="7" />
    <div class="page_course_public">
      <div class="banner"></div>
      <div class="coursebox">
        <div class="wrap">
          <div class="left">
            <div class="left_circle"></div>
            <div class="left_line"></div>
          </div>
          <div class="right">
            <div class="course_dateday">
              <span class="course_date">08-25</span>
              <span class="course_day">周二</span>
            </div>
            <div class="course_infos">
              <div class="course_imgbox">
                <img src alt class="pic_full" />
              </div>
              <div class="course_infobox">
                <div class="course_infoleft">
                  <div class="course_timename">
                    <span class="course_time">20:30</span>
                    <span class="course_name">project name</span>
                  </div>
                  <div
                    class="course_info"
                  >他的好朋友Benny去动物园玩，他们看到了哪些动物，发生了哪些有趣的事呢？我们一起去看看吧。 句型： They are/It is ...它们是/它是... They have ... 它们有... 词汇： elephant 大象, rabbit 兔子, scary 可怕的, dangerous 危险的</div>
                  <div class="course_gradetip">
                    <span class="course_grade">初级</span>
                    <span class="course_tip">剩余</span>
                  </div>
                </div>
                <div class="course_inforight">
                  <div class="teacher_img">
                    <img class="pic_full" />
                  </div>
                  <div class="teacher_name">ccc</div>
                  <div class="course_book">
                      <i class="el-icon-loading"></i>
                    <span class="icon"></span>
                    <span class="text">预约体验</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="historycoursebox">
          <div class="titlebox">
            <div class="title">往期直播</div>
          </div>
          <div class="historycourses">
            <div class="courseitem">
              <div class="logo"></div>
              <div class="course_img">
                <img src alt class="pic_full" />
              </div>
              <div class="course_name">test</div>
              <div
                class="course_info"
              >fdsfsdfsdfsdfdsfdsfdsfffffffffffffffffffffffffffffffffffdsfsdfdfdsfsdfsdfsdfdsfdsfdsfsdfds</div>
              <div class="course_bottom">
                <span class="left">
                  <img src alt class="pic_full" />
                </span>
                <span class="middle">
                  <div class="teacher_name">testtst</div>
                  <div class="person">
                    <span>9999</span>位学生参加
                  </div>
                </span>
                <span class="right">
                  <div class="checkvideo">查看回放</div>
                </span>
              </div>
            </div>
            <div class="courseitem">
              <div class="logo"></div>
              <div class="course_img">
                <img src alt class="pic_full" />
              </div>
              <div class="course_name">test</div>
              <div
                class="course_info"
              >fdsfsdfsdfsdfdsfdsfdsfffffffffffffffffffffffffffffffffffdsfsdfdfdsfsdfsdfsdfdsfdsfdsfsdfds</div>
              <div class="course_bottom">
                <span class="left">
                  <img src alt class="pic_full" />
                </span>
                <span class="middle">
                  <div class="teacher_name">testtst</div>
                  <div class="person">
                    <span>9999</span>位学生参加
                  </div>
                </span>
                <span class="right">
                  <div class="checkvideo">查看回放</div>
                </span>
              </div>
            </div>
            <div class="courseitem">
              <div class="logo"></div>
              <div class="course_img">
                <img src alt class="pic_full" />
              </div>
              <div class="course_name">test</div>
              <div
                class="course_info"
              >fdsfsdfsdfsdfdsfdsfdsfffffffffffffffffffffffffffffffffffdsfsdfdfdsfsdfsdfsdfdsfdsfdsfsdfds</div>
              <div class="course_bottom">
                <span class="left">
                  <img src alt class="pic_full" />
                </span>
                <span class="middle">
                  <div class="teacher_name">testtst</div>
                  <div class="person">
                    <span>9999</span>位学生参加
                  </div>
                </span>
                <span class="right">
                  <div class="checkvideo">查看回放</div>
                </span>
              </div>
            </div>
            <div class="courseitem">
              <div class="logo"></div>
              <div class="course_img">
                <img src alt class="pic_full" />
              </div>
              <div class="course_name">test</div>
              <div
                class="course_info"
              >fdsfsdfsdfsdfdsfdsfdsfffffffffffffffffffffffffffffffffffdsfsdfdfdsfsdfsdfsdfdsfdsfdsfsdfds</div>
              <div class="course_bottom">
                <span class="left">
                  <img src alt class="pic_full" />
                </span>
                <span class="middle">
                  <div class="teacher_name">testtst</div>
                  <div class="person">
                    <span>9999</span>位学生参加
                  </div>
                </span>
                <span class="right">
                  <div class="checkvideo">查看回放</div>
                </span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <Pagination background layout="prev,pager,next" :total="total" />
          </div>
        </div>
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
    </div>
  </div>
</template>

<script>
import { common } from "../../../common";
import commonhead from "../common/common_head";
import commonfoot from "../common/common_foot";
import { Pagination } from "element-ui";
export default {
  components: {
    commonhead,
    commonfoot,
    Pagination,
  },
  data: function () {
    return {
      total: 1,
    };
  },
  mounted: function () {},
  methods: {},
};
</script>
<style scoped src="./index.css"></style>